'use client';

import FsSection7 from '@enlighten/landing/dist/fs-roof/@section7';

export default function Section7() {
	return (
		<FsSection7
			onClick={() => {
				window.open(`https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=21052751044633`, '_blank');
			}}
		/>
	);
}
